import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestSwitchBrand } from "./switch_brand_actions";
import Select from "react-select";

const fieldStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: "#C4C4C4",
    boxShadow: null,
    marginBottom: "12px",
    borderRadius: "10px",
    "&:hover": {
      borderColor: "#C4C4C4",
    },
  }),
};

const NavSelectBrand = ({ brands }) => {
  const [id, setId] = useState(Cookies.get("bId"));
  const dispatch = useDispatch();

  const selectedBrandReducer = useSelector(
    (state) => state.selectedBrandReducer
  );
  const { brand_id } = selectedBrandReducer;

  const brandList = brands.map((k) => {
    return {
      value: k._id,
      label: k.name,
    };
  });
  const brandNames = Object.fromEntries(brands.map((k) => [k._id, k.name]));

  useEffect(() => {
    //Handle refresh case
    dispatch(requestSwitchBrand({ brand_id: id, brand_name: brandNames[id] }));
  }, []);

  const update = (event) => {
    setId(event.value);
    Cookies.set("bId", event.value);
    dispatch(
      requestSwitchBrand({
        brand_id: event.value,
        brand_name: brandNames[event.value],
      })
    );
  };

  // const switchBrand = () => {
  //   Cookies.set("bId", id);
  //   dispatch(requestSwitchBrand({ brand_id: id, brand_name: brandNames[id] }));
  // };

  return (
    <Select
      onChange={update}
      options={brandList}
      defaultValue={brandList.find((k) => k.value === id)}
      styles={fieldStyles}
      className="mt-2 ms-1 me-1"
    />
  );
};
export default React.memo(NavSelectBrand);
